import api from "../../api";

class CourseApi {
  static getAll() {
    return api.get("/course/getAllCourse");
  }

  static getOne(id) {
    return api.get(`/course/getCourse/?id=${id}`);
  }
}

export default CourseApi;
